import * as React from 'react';
import { getConfig, getExperimentVariantFromConfig } from '../../config';
import { escape, purifyHtml } from '../../utils/component/helpers';
import { logCreativeLoad, logCreativeClick } from '../../utils/logger';
import { useEffect } from 'react';
import { UNLEASH_FEATURE_NAMES } from '../../../shared/unleash-feature-names';
import { setUrlHttpsIfMissing } from '../../utils/string';
import { getHtml } from './content-marketing-experiment-html';

type Props = {
    id: string;
    isFrontpage?: boolean;
};

export type MarketContentDesignExperimentVariants =
    | undefined
    | 'control'
    | 'challengerLargerStripAndLogo';

export function ContentMarketing(props: Props) {
    const { id, isFrontpage } = props;
    const contentMarketing = getConfig()?.contentMarketing;

    const marketContentDesignVariant = getExperimentVariantFromConfig(
        UNLEASH_FEATURE_NAMES.enableMarketContentDesignExperiment,
    ) as MarketContentDesignExperimentVariants;

    useEffect(() => {
        if (document) {
            logCreativeLoad(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentMarketing, id]);

    if (contentMarketing) {
        const htmlContent = {
            escapedImgUrl: escape(contentMarketing.image.url),
            escapedIconUrl: escape(contentMarketing.icon.url),
            escapedSponsor: escape(contentMarketing.sponsor),
            escapedHref: escape(setUrlHttpsIfMissing(contentMarketing.href)),
            escapedTitle: escape(contentMarketing.title),
            escapedText: escape(contentMarketing.text),
        };

        const html = getHtml(
            isFrontpage,
            htmlContent,
            marketContentDesignVariant,
        );
        return (
            <div
                onClick={() =>
                    logCreativeClick(
                        id,
                        htmlContent.escapedSponsor,
                        htmlContent.escapedHref,
                    )
                }
                id={id}
                dangerouslySetInnerHTML={{ __html: purifyHtml(html) }}
            />
        );
    }
    return null;
}
